// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"26dcdee5","405":"6488127a","602":"c8d3375b","801":"74a6bd24","855":"d6dc12b0"}[chunkId] + ".chunk.css";
};